import { FC, useState } from 'react'

import { SetUserProfileRoute } from '../../../hooks/useUserProfileRoute'
import { UserProfileScreens } from '../../../lib/types'
import { UserAutoScreen } from './UserAutoScreen' // форма
import { UserAutosScreen } from './UserAutosScreen' // список

type Props = {
  onClose: () => void
  userProfileRoute: { screen: string; entityId?: string }
  setUserProfileRoute: SetUserProfileRoute
}

const UserAutoWrapper: FC<Props> = ({
  onClose,
  userProfileRoute,
  setUserProfileRoute
}) => {
  const [savedToastMessage, setSavedToastMessage] = useState<string | null>(
    null
  )

  const isListScreen = userProfileRoute.screen === UserProfileScreens.Autos
  const isFormScreen = userProfileRoute.screen === UserProfileScreens.Auto

  return (
    <>
      {isListScreen && (
        <UserAutosScreen
          onClose={onClose}
          setUserProfileRoute={setUserProfileRoute}
          savedToastMessage={savedToastMessage}
          onSavedAutoNumberShown={() => setSavedToastMessage(null)}
        />
      )}

      {isFormScreen && (
        <UserAutoScreen
          autoId={userProfileRoute.entityId}
          setUserProfileRoute={setUserProfileRoute}
          onSavedToastMessage={setSavedToastMessage}
        />
      )}
    </>
  )
}

export { UserAutoWrapper }
